import BuildingConstant from "../Constants/BuildingConstants";
import dispatcher from "../Dispatcher/Dispatcher";
import config from "./../Config/Config";
import httpRequest from "./../HttpRequests/HttpRequest";

class Building_Action {
  getBuildingList(plantId) {
    httpRequest(
      config.webServiceURL + "/Building/Gets/" + plantId,
      "GET",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: BuildingConstant.GET_BUILDING_LIST_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: BuildingConstant.GET_BUILDING_LIST_FAILURE,
            res,
          });
        }
      }
    );
  }

  addOrUpdateBuildingByPlantId(buildInfo) {
    httpRequest(
      config.webServiceURL + "/Building/SaveUpdateBuilding/",
      "POST",
      JSON.stringify({
        ID: buildInfo.ID,
        WerkID: buildInfo.WerkID,
        Bau: buildInfo.Bau,
      }),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: BuildingConstant.ADD_OR_UPDATE_BUILDING_LIST_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: BuildingConstant.ADD_OR_UPDATE_BUILDING_LIST_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  deleteBuilding(plantId, buildID) {
    httpRequest(
      config.webServiceURL + "/Building/Delete/" + plantId,
      "DELETE",
      JSON.stringify([...buildID]),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: BuildingConstant.DEL_BUILDING_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: BuildingConstant.DEL_BUILDING_FAILURE,
            result: message,
          });
        }
      }
    );
  }
}
export default new Building_Action();
